import * as Yup from 'yup';

export const ChangeStatusSchema = Yup.object().shape({
  // comment: Yup.string().required('El comentario es requerido'),
  comment: Yup.string().required('academic.requisition.review.comment.required'),
});
